import { fetcher } from "@/services/api/fetcher";
import { useQuery } from "@tanstack/react-query";
import { OwnershipStatusResponse } from "./interface";

//SECTION - Get All Alsintan
const getOwnership = async (
  query?: string
): Promise<ApiResponse<DataPaginate<OwnershipStatusResponse>>> => {
  return await fetcher(
    query ? `/master/status-kepemilikan?${query}` : `/master/status-kepemilikan`
  );
};

export const useGetOwnership = (query?: string) => {
  return useQuery<ApiResponse<DataPaginate<OwnershipStatusResponse>>, Error>({
    queryKey: ["useGetOwnership", query],
    queryFn: () => getOwnership(query),
    keepPreviousData: true,
    refetchIntervalInBackground: true,
  });
};
